<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  >
  </Navbar>
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="card bg-white rounded shadow border-0 mt-5 card-nav-tabs">
          <div class="card-header rounded card-header-primary">
            <div class="nav-tabs-navigation">
              <div class="nav-tabs-wrapper">
                <ul class="nav nav-tabs text-xxs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link"
                    :class="{ active: active_tab === 'users' }"
                    @click="setactive_tab('users')"
                    id="nav-users-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-users"
                    type="button"
                    role="tab"
                    aria-controls="nav-users"
                    aria-selected="active_tab === 'users'"
                  >
                    All users
                  </button>

                  <button
                    class="nav-link"
                    :class="{ active: active_tab === 'admin' }"
                    @click="setactive_tab('admin')"
                    id="nav-admin-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-admin"
                    type="button"
                    role="tab"
                    aria-controls="nav-admin"
                    aria-selected="active_tab === 'admin'"
                  >
                    Admin
                  </button>

                  <button
                    class="nav-link"
                    :class="{ active: active_tab === 'user' }"
                    @click="setactive_tab('user')"
                    id="nav-user-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-user"
                    type="button"
                    role="tab"
                    aria-controls="nav-user"
                    aria-selected="active_tab === 'user'"
                  >
                    User
                  </button>
                </ul>
              </div>
            </div>
            <!-- <span class="fw-500">All users</span> -->

            <div
              class="modal fade"
              id="create_user"
              tabindex="-1"
              aria-labelledby="create_userLabel"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
              >
                <div class="modal-content">
                  <div
                    class="modal-header bg-primary text-white position-relative"
                  >
                    <p
                      class="modal-title text-xxs fw-500"
                      id="create_user_label"
                    >
                      Create User
                    </p>
                    <button
                      type="button"
                      class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form @submit.prevent="submit_form">
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-6">
                          <label
                            for="first_name"
                            class="form-label text-xxs fw-500"
                            >First Name
                            <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="first_name"
                            placeholder="Enter first name"
                            v-model="first_name"
                          />
                          <p
                            v-if="errors.first_name"
                            class="text-danger text-xxs"
                          >
                            {{ errors.first_name }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <label
                            for="last_name"
                            class="form-label text-xxs fw-500"
                            >Last Name <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="last_name"
                            placeholder="Enter last name"
                            v-model="last_name"
                          />
                          <p
                            v-if="errors.last_name"
                            class="text-danger text-xxs"
                          >
                            {{ errors.last_name }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <label
                            for="phone_number"
                            class="form-label text-xxs fw-500"
                            >Phone Number</label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="phone_number"
                            placeholder="Enter phone number"
                            v-model="phone_number"
                          />
                          <p
                            v-if="errors.phone_number"
                            class="text-danger text-xxs"
                          >
                            {{ errors.phone_number }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <label for="email" class="form-label text-xxs fw-500"
                            >Email<span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="email"
                            placeholder="example@gmail.com"
                            v-model="email"
                          />
                          <p v-if="errors.email" class="text-danger text-xxs">
                            {{ errors.email }}
                          </p>
                        </div>
                        <div class="mb-3">
                          <label
                            for="user_role"
                            class="form-label text-xxs fw-500"
                            >User Role<span class="text-danger">*</span></label
                          >
                          <select
                            class="form-select rounded text-xxs"
                            id="user_role"
                            v-model="user_role"
                          >
                            <option selected hidden>Select Role</option>
                            <option
                              v-for="role in roles"
                              :value="role.role"
                              :key="role.id"
                            >
                              {{ role.role }}
                            </option>
                          </select>
                          <p
                            v-if="errors.user_role"
                            class="text-danger text-xxs"
                          >
                            {{ errors.user_role }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="submit"
                        class="btn btn-primary text-xxs rounded"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="modal fade"
              id="edit_user"
              tabindex="-1"
              aria-labelledby="edit_user_label"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
              >
                <div class="modal-content">
                  <div
                    class="modal-header bg-primary text-white position-relative"
                  >
                    <p class="modal-title text-xxs fw-500" id="edit_user_label">
                      Edit User
                    </p>
                    <button
                      type="button"
                      class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form @submit.prevent="update_user">
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-6">
                          <label
                            for="first_name"
                            class="form-label text-xxs fw-500"
                            >First Name
                            <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="first_name"
                            placeholder="Enter first name"
                            v-model="edit_form.first_name"
                          />
                          <p
                            v-if="errors.first_name"
                            class="text-danger text-xxs"
                          >
                            {{ errors.first_name }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <label
                            for="last_name"
                            class="form-label text-xxs fw-500"
                            >Last Name <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="last_name"
                            placeholder="Enter last name"
                            v-model="edit_form.last_name"
                          />
                          <p
                            v-if="errors.last_name"
                            class="text-danger text-xxs"
                          >
                            {{ errors.last_name }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <label
                            for="phone_number"
                            class="form-label text-xxs fw-500"
                            >Phone Number</label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="phone_number"
                            placeholder="Enter phone number"
                            v-model="edit_form.phone_number"
                          />
                          <p
                            v-if="errors.phone_number"
                            class="text-danger text-xxs"
                          >
                            {{ errors.phone_number }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <label for="email" class="form-label text-xxs fw-500"
                            >Email<span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control rounded text-xxs"
                            id="email"
                            placeholder="example@gmail.com"
                            v-model="edit_form.email"
                          />
                          <p v-if="errors.email" class="text-danger text-xxs">
                            {{ errors.email }}
                          </p>
                        </div>

                        <div class="mb-3">
                          <label
                            for="user_role"
                            class="form-label text-xxs fw-500"
                            >User Role<span class="text-danger">*</span></label
                          >
                          <select
                            class="form-select rounded text-xxs"
                            id="user_role"
                            v-model="edit_form.user_role"
                          >
                            <option selected hidden>Select Role</option>
                            <option
                              v-for="role in roles"
                              :value="role.role"
                              :key="role.id"
                            >
                              {{ role.role }}
                            </option>
                          </select>
                          <p
                            v-if="errors.user_role"
                            class="text-danger text-xxs"
                          >
                            {{ errors.user_role }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="submit"
                        class="btn btn-primary text-xxs rounded"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-users"
              role="tabpanel"
            >
              <div class="card-body table-responsive mb-5">
                <button
                  class="btn btn-primary btn-sm mb-2 rounded"
                  data-bs-toggle="modal"
                  data-bs-target="#create_user"
                > Create User
                </button>

                <button
                  @click="exportToCSV"
                  class="btn btn-primary btn-sm mx-2 mb-2 rounded"
                >
                  Export to CSV
                </button>

                <table
                  id="usersTable"
                  class="table table-striped text-xxs w-100"
                >
                  <thead class="btn-primary text-white">
                    <tr>
                      <th>No</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Phone Number</th>
                      <th>Is Active</th>
                      <th>Last Login</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in filteredUsers" :key="user.id">
                      <th scope="row">{{ index + 1 }}</th>
                      <td>{{ user.first_name }}</td>
                      <td>{{ user.last_name }}</td>
                      <td>{{ user.email }}</td>
                      <td>{{ user.phone_number }}</td>
                      <td>{{ user.is_active }}</td>
                      <td>{{ user.last_login }}</td>
                      <td v-if="String(user.id) !== String(logged_in_user_id)">
                        <button
                          class="btn btn-light btn-sm text-success border"
                          @click="edit_user(user)"
                        >
                          Edit
                        </button>

                        <button
                          v-if="user.is_active"
                          class="btn btn-light btn-sm text-danger border"
                          @click="confirm_deactivation(user.id)"
                        >
                          Deactivate
                        </button>

                        <button
                          v-else
                          class="btn btn-light btn-sm text-success border"
                          @click="confirm_activation(user.id)"
                        >
                          Activate
                        </button>

                        <button
                          class="btn btn-light btn-sm text-danger border"
                          @click="delete_user(user.id)"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-admin" role="tabpanel">
              <div class="card-body table-responsive">
                <table
                  id="adminTable"
                  class="table table-striped text-xxs w-100"
                >
                  <thead class="btn-primary text-white">
                    <tr>
                      <th>No</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Phone Number</th>
                      <th>Is Active</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in filteredAdmin" :key="user.id">
                      <th scope="row">{{ index + 1 }}</th>
                      <td>{{ user.first_name }}</td>
                      <td>{{ user.last_name }}</td>
                      <td>{{ user.email }}</td>
                      <td>{{ user.phone_number }}</td>
                      <td>{{ user.is_active }}</td>
                      <td v-if="user.id != logged_in_user_id">
                        <button
                          class="btn btn-light btn-sm text-success border"
                          @click="edit_user(user)"
                        >
                          Edit
                        </button>

                        <button
                          v-if="user.is_active"
                          class="btn btn-light btn-sm text-danger border"
                          @click="confirm_deactivation(user.id)"
                        >
                          Deactivate
                        </button>

                        <button
                          v-else
                          class="btn btn-primary btn-sm"
                          @click="confirm_activation(user.id)"
                        >
                          Activate
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              class="tab-pane fade w-100"
              id="nav-user"
              role="tabpanel"
              aria-labelledby="nav-user-tab"
            >
              <div class="card-body table-responsive w-100">
                <table
                  id="NormalUsersTable"
                  class="table table-striped text-xxs w-100"
                >
                  <thead class="btn-primary text-white">
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Phone Number</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody class="text-black">
                    <tr
                      v-for="(user, index) in filteredCustomer"
                      :key="user.id"
                    >
                      <th>{{ index + 1 }}</th>
                      <td>{{ user.first_name }}</td>
                      <td>{{ user.last_name }}</td>
                      <td>{{ user.email }}</td>
                      <td>{{ user.phone_number }}</td>

                      <td>
                        <button
                          class="btn btn-light btn-sm rounded-3 text-success border text-xxs me-1"
                          @click="edit_user(user)"
                          v-if="user.id != logged_in_user_id"
                        >
                          Edit
                        </button>

                        <button
                          class="btn btn-light btn-sm rounded-3 text-danger border text-xxs"
                          @click="confirm_deactivation(user.id)"
                          v-if="user.is_active"
                        >
                          Deactivate
                        </button>

                        <button
                          class="btn btn-primary text-xxs rounded-3 mx-1 btn-sm shadow"
                          @click="confirm_activation(user.id)"
                          v-else
                        >
                          Activate
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
